import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import rootReducer from "../reducers/index";

import thunk from 'redux-thunk';
import {i18nReducer} from 'react-redux-i18n';
import {saveState} from '../localStorage';

const composeEnhancers = process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
	window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

const store = createStore(
	combineReducers({
		rootReducer,
		i18n: i18nReducer,
	}),
	composeEnhancers(applyMiddleware(thunk))
);


store.subscribe(() => {
	saveState({
		config: store.getState().rootReducer.config,
	});
});

export default store;
